import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class TaxExemptionService extends AbstractService {
	static endpoint = ENDPOINTS.taxExemptions;

	static getCounts() {
		return this.get({ endpoint: `${this.endpoint}/counts` });
	}

	static getExemptionRequests({ queryParams, getCancelToken }) {
		return this.get({
			endpoint: this.endpoint,
			queryParams,
			getCancelToken,
		});
	}

	static validateExemption(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/validate`,
			queryParams,
			data,
		});
	}
}
